<template>
  <div class="mega-menu-region">
    <slot name="mega-header" />
    <div class="mega-menu-content">
      <div class="content-container">
        <div class="mega-menu-inner-row">
          <div class="mega-menu-inner-content">
            <div
              class="mega-menu-nav-region"
              :style="displayGridSize"
            >
              <div
                v-for="(menu, index) in menus"
                :key="`menu-layout-${menu.id}-${index}`"
                class="menu-column"
              >
                <menuBlock
                  v-if="menu.type === 'container'"
                  :list="menu.columns"
                  :title="menu.linkText"
                  @close-dropdown="$emit('close-dropdown')"
                />
                <HighlightButton
                  v-else
                  :url="menu.linkUrl"
                  :router-link="true"
                  :title="menu.linkText"
                  button-type="default"
                  :url-new-window="menu.linkTarget === '_blank'"
                  @highlight-button-click="$emit('close-dropdown')"
                />
              </div>
            </div>
            <ButtonBlock :content="actions" />
          </div>
          <div
            v-if="ctas && ctas.length > 0"
            class="mega-menu-cta-region"
            :style="displayBlockWidth"
          >
            <div class="mega-menu-cta-title-region">
              <h4 class="title">
                {{ ctasConfig.groupHeading }}
              </h4>
            </div>
            <GridDisplayAspect
              :content="ctas"
              :grid-item-width="parseInt(ctasConfig.gridItemWidth)"
              :grid-gap="ctasConfig.gridGap"
              :row-sizing="ctasConfig.gridRowSizing"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GridDisplayAspect from './components/grids/aspect-ratio-locked-grid.vue'
import menuBlock from './menu-block.vue'
import ButtonBlock from './button-group-block.vue'
import HighlightButton from './components/button/highlight-button.vue'

export default {
  components: {
    GridDisplayAspect,
    menuBlock,
    ButtonBlock,
    HighlightButton
  },
  props: {
    content: {
      type: Object,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {
      menus: this.content.columns ?? [],
      ctas: this.content.ctas?.linkItems ?? [],
      ctasConfig: this.content.ctaConfig ?? {},
      actions: this.content.actions?.linkItems ?? []
    }
  },
  computed: {
    displayBlockWidth() {
      return {
        '--cta-width': `${this.ctasConfig.ctaBlockWidth}%` // css variables used instead of straight inline style values here for greater control over styling
      }
    },
    displayGridSize() {
      return {
        '--grid-size': `${this.menus.length}` // css variables used instead of straight inline style values here for greater control over styling
      }
    },
    collapsible() {
      return this.groupCollapsible
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.menu-column {
    @include media-breakpoint-down(md) {
        &:not(:last-child){
            border-bottom: 1px solid;
            border-color:var(--mega-menu-border-color);
            padding-bottom: 1em;
        }
    }
}
.mega-menu-inner-content {
    display: grid;
    gap:1em;
    grid-auto-rows: min-content;
    width: 100%;
    justify-content: flex-start;

}

.mega-menu-inner-row {
    display:flex;
    gap: 1em;
    flex-direction: column;
    @include media-breakpoint-up(lg) {
        flex-direction: row;
        justify-content: space-between;
    }
}

.mega-menu-region {
    --mega-menu-background:#fff;
    --mega-menu-border-color:rgba(0, 0, 0, 0.1);
    --menu-block-title-font-size: 1.2em;
    --menu-block-title-font-weight:400;
    background:var(--mega-menu-background);
    height: 100%;
    width: 100%;
    display:flex;
    flex-direction: column;
    overflow-y: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
}
.mega-menu-content {
    padding: 2em 0em;
    //height: 100%;
    .content-container {
        max-width: var(--mega-menu-inner-max-width);
        margin: 0 auto;
        padding: 0 var(--mega-container-padding, 1em);
    }
}
.mega-menu-nav-region {
    width:auto;
}
.mega-menu-cta-region {
    min-width:100%;
    @include media-breakpoint-up(lg) {
        min-width: var(--cta-width);
    }
    .title {
        font-size:var(--menu-block-title-font-size);
        font-weight: var(--menu-block-title-font-weight);
    }
}

.mega-menu-nav-region {
    @include media-breakpoint-down(md) {
        --grid-size:1 !important;
    }
    --gap: 1.5em;
    display: grid;
    grid-template-columns: repeat(var(--grid-size), 1fr);
    grid-gap: var(--gap);
}
</style>
